import { useBoolean } from 'react-use';

import { useMediaElementListener } from './useMediaElementListener';

export const useVideoIsPlaying = (videoElement: HTMLVideoElement) => {
  const [isPlaying, setIsPlaying] = useBoolean(!videoElement.paused);

  useMediaElementListener(videoElement, 'play', () => setIsPlaying(true));
  useMediaElementListener(videoElement, 'pause', () => setIsPlaying(false));

  return isPlaying;
};
